"use client";

import { TextareaProps, TextInputProps } from "@mantine/core";
import { Textarea, TextInput } from "@mantine/core";
import cx from "clsx";
import classes from "./index.module.css";
import { ReactNode } from "react";
import React, { useState } from "react";
import { getInputProps } from "@/components/inputProps";
import { IMaskInput } from "react-imask";

type BaseInputProps = {
  isSectionDropdown?: boolean;
  /** Marks the rendered input as containing personal data so analytics tools exclude it (adds the `piiData` class). */
  pii?: boolean;
  component?: ReactNode | typeof IMaskInput;
  mask?: string;
  onAccept?: (value: string) => void;
};

export type InputProps = BaseInputProps &
  (
    | ({
        multiline: true;
      } & TextareaProps)
    | ({
        multiline?: false | undefined;
      } & TextInputProps)
  );

const Input = ({ isSectionDropdown = false, pii = false, ...textFieldProps }: InputProps) => {
  const [focused, setFocused] = useState(false);
  const InputComponent = textFieldProps.multiline ? Textarea : TextInput;

  const numberInputOnWheelPreventChange = (e: React.WheelEvent<HTMLInputElement> | React.WheelEvent<HTMLTextAreaElement>) => {
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
      e.target.blur();
    }
  };
  return (
    <InputComponent
      {...(textFieldProps as TextInputProps & TextareaProps)}
      {...getInputProps(textFieldProps, focused)}
      className={cx(textFieldProps.className, { piiData: pii })}
      classNames={{
        ...classes,
        ...textFieldProps.classNames,
      }}
      onFocus={() => setFocused(true)}
      onBlur={e => {
        (textFieldProps as TextInputProps).onBlur?.(e as React.FocusEvent<HTMLInputElement>);
        setFocused(false);
      }}
      wrapperProps={{
        "data-focused": focused,
        "data-left-section-dropdown": isSectionDropdown,
      }}
      size="lg"
      onWheel={e => numberInputOnWheelPreventChange(e)}
    />
  );
};

export default Input;
